import React from 'react';

import {Link} from 'react-router-dom'

import classes from './LinkButton.module.scss';

const LinkButton = (props) => {

    const lc = [];
    if(props.noDecoration){
        lc.push(classes.noDecoration)
    }

    if(props.underline){
        lc.push(classes.underline)
    }

    return (
        <Link className={classes.linkButton+" para-2 "+ lc.join(' ')+" " +(props.className?props.className:"")}  to={props.to}>{props.children}</Link>
    );
};


export default LinkButton;
